class Monitoring.Models.LoginSetting extends Backbone.Model
  urlRoot: '/keepcon/settings/account_setting/login_setting'

  defaults:
    active: false
    realm: ''
    login_code: ''
    expiration: 1
